import React from 'react';
import styled from 'styled-components';
import { Divider } from 'antd';
import { AmountFormat } from '@monavate/ui-core';
import PaymentInstructionStatus from '@/components/PaymentInstructionStatus/PaymentInstructionStatus';

const PaymentContainer = styled.div`
    border: 1px solid ${(props) => props.theme['Borders/quiet']};
    padding: 12px 16px;
`;

const PaymentHeader = styled.div`
    display: flex;
    justify-content: space-between;
`;

const StatusContainer = styled.div`
    overflow: hidden;
`;

const ItemTitle = styled.div`
    font-weight: 500;
    color: ${(props) => props.theme['Content/muted']}
        /* TODO: check color. Alternatives: ["Content/muted","Borders/hover"] */;
    font-weight: 400;
    line-height: 20px;
    font-size: 12px;
`;

const ItemValue = styled.div`
    font-size: 14px;
    font-weight: 600;
    line-height: 22px;
    color: ${(props) => props.theme['Content/primary']}
        /* TODO: check color. Alternatives: ["Content/primary","Content/logo","Content/on-accent"] */;
`;

const IdContainer = styled.div`
    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
    color: ${(props) => props.theme['Content/primary']}
        /* TODO: check color. Alternatives: ["Content/primary","Content/logo","Content/on-accent"] */;
`;

const PaymentContent = styled.div`
    display: flex;
    justify-content: space-between;
`;

const PaymentFooter = styled.div`
    display: flex;
    justify-content: space-between;
`;

interface PaymentOptionProps {
    payment: any;
}

const PaymentOption: React.FC<PaymentOptionProps> = ({ payment }) => {
    return (
        <PaymentContainer>
            <PaymentHeader>
                <b>{payment.supplierName || 'Payment'}</b>
                <StatusContainer>
                    <PaymentInstructionStatus status={payment.status} />
                </StatusContainer>
            </PaymentHeader>
            <PaymentContent>
                <div>
                    <ItemTitle>Card type</ItemTitle>
                    <ItemValue>{payment?.card?.singleUse ? 'Single-use' : 'Multi-use'}</ItemValue>
                </div>
                <div>
                    <ItemTitle>Amount</ItemTitle>
                    <ItemValue>
                        <AmountFormat amount={payment.amount} currency={payment.currency} letters />
                    </ItemValue>
                </div>
            </PaymentContent>
            <Divider style={{ margin: '8px 0' }} />
            <PaymentFooter>
                <div>
                    <ItemTitle>Contains payment instruction ID</ItemTitle>
                    <IdContainer>{payment.id}</IdContainer>
                </div>
            </PaymentFooter>
        </PaymentContainer>
    );
};

export default PaymentOption;
